module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "organization-update update-form"
  }, [_c('form', {
    staticClass: "email-template-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "email_template",
      "name": "name"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "language",
      "required": true,
      "placeholder": "en"
    },
    model: {
      value: (_vm.item.language),
      callback: function($$v) {
        _vm.$set(_vm.item, "language", $$v)
      },
      expression: "item.language"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "from",
      "placeholder": "John Smith"
    },
    model: {
      value: (_vm.item.from),
      callback: function($$v) {
        _vm.$set(_vm.item, "from", $$v)
      },
      expression: "item.from"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "reply_to",
      "placeholder": "noreply@example.com"
    },
    model: {
      value: (_vm.item.reply_to),
      callback: function($$v) {
        _vm.$set(_vm.item, "reply_to", $$v)
      },
      expression: "item.reply_to"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('field', {
    ref: "salutation",
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "salutation",
      "placeholder": "Hi [[firstname]]"
    },
    model: {
      value: (_vm.item.salutation),
      callback: function($$v) {
        _vm.$set(_vm.item, "salutation", $$v)
      },
      expression: "item.salutation"
    }
  }), _vm._v(" "), _c('field-filler', {
    attrs: {
      "elements": _vm.$refs,
      "element-name": "salutation",
      "values": _vm.placeholderSalutationCollection
    },
    model: {
      value: (_vm.item.salutation),
      callback: function($$v) {
        _vm.$set(_vm.item, "salutation", $$v)
      },
      expression: "item.salutation"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "salutation_fallback",
      "placeholder": "Hi dear"
    },
    model: {
      value: (_vm.item.salutation_fallback),
      callback: function($$v) {
        _vm.$set(_vm.item, "salutation_fallback", $$v)
      },
      expression: "item.salutation_fallback"
    }
  }), _vm._v(" "), _c('field', {
    ref: "body",
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "body",
      "type": "textarea",
      "required": true
    },
    model: {
      value: (_vm.item.body),
      callback: function($$v) {
        _vm.$set(_vm.item, "body", $$v)
      },
      expression: "item.body"
    }
  }), _vm._v(" "), _c('field-filler', {
    attrs: {
      "elements": _vm.$refs,
      "element-name": "body",
      "values": _vm.placeholderBodyCollection
    },
    model: {
      value: (_vm.item.body),
      callback: function($$v) {
        _vm.$set(_vm.item, "body", $$v)
      },
      expression: "item.body"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "imprint_url"
    },
    model: {
      value: (_vm.item.imprint_url),
      callback: function($$v) {
        _vm.$set(_vm.item, "imprint_url", $$v)
      },
      expression: "item.imprint_url"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "email_template",
      "name": "privacy_url"
    },
    model: {
      value: (_vm.item.privacy_url),
      callback: function($$v) {
        _vm.$set(_vm.item, "privacy_url", $$v)
      },
      expression: "item.privacy_url"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary",
    attrs: {
      "data-action": "email-templates.cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-save",
    attrs: {
      "type": "submit",
      "data-action": "email-templates.update"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9164a9f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/email_templates/EmailTemplateUpdate.vue
// module id = 1965
// module chunks = 0